import React, {useContext, useState} from "react";
import AuthContext, {useAuth} from "../context/AuthContext";
import {Button, Card, IconButton, InputAdornment, TextField, Alert, CircularProgress, Box} from "@mui/material";
import logo from "../assets/Tourguide logo.png"
import bg from "../assets/tgsbg.webp"
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import TFAVerification from '../components/TFAVerification';
import { useSnackbar } from 'notistack';
import {useHistory} from "react-router-dom";

const LoginPage = () => {
    const {loginUser, showTFA, tfaToken} = useAuth();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('')
    const history = useHistory()

    const { enqueueSnackbar } = useSnackbar();

    const handleLogin = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const email = formData.get('email');
        const password = formData.get('password');

        try {
            setIsLoading(true);
            setError('');
            loginUser({email: email, password: password})
        } catch (err) {
            setError('Hibás email cím vagy jelszó');
        } finally {
            setIsLoading(false);
        }
    };

    const handleTFASuccess = (response) => {
        history.push('/')
    };

    if (showTFA) {
        return (
            <div style={{width: '100vw', height: '100vh', background: `url(${bg})`, backgroundRepeat: 'no-repeat', backgroundSize: "cover", backgroundPosition: 'center'}}>
                <Card className="login">
                    <img src={logo} alt="Logo" style={{
                        width: "30%",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto"
                    }}/>
                    <Box maxWidth={400} width="100%" className='form'>
                        <TFAVerification
                            token={tfaToken}
                            onSuccess={handleTFASuccess}
                        />
                    </Box>
                </Card>
            </div>
        );
    }

    return (
        <div style={{width: '100vw', height: '100vh', background: `url(${bg})`, backgroundRepeat: 'no-repeat', backgroundSize: "cover", backgroundPosition: 'center'}}>
            <Card className="login">
                <img src={logo} alt="Logo" style={{
                    width: "30%",
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto"
                }}/>
                <form className="form" onSubmit={handleLogin}>
                    <TextField
                        className="inp"
                        label="Email"
                        id="email"
                        name="email"
                        formControlProps={{
                            fullWidth: true,
                        }}
                        type="text"
                        margin="dense"
                        required
                    />

                    <TextField 
                        className="inp"
                        label="Jelszó"
                        id="password"
                        name="password"
                        margin="dense"
                        formControlProps={{
                            fullWidth: true,
                        }} 
                        type={passwordVisible ? "text" : "password"} 
                        required
                        InputProps={{
                            endAdornment: <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                    edge="end"
                                >
                                    {passwordVisible ? <VisibilityOffRoundedIcon /> : <VisibilityRoundedIcon />}
                                </IconButton>
                            </InputAdornment>
                        }}
                    />

                    {error && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <Button 
                        color="primary" 
                        variant="outlined" 
                        type="submit" 
                        className="form__custom-button"
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} /> : 'Bejelentkezés'}
                    </Button>
                </form>
            </Card>
        </div>
    );
};

export default LoginPage;
